import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentTwoFactorAuthenticationEffects } from './two-factor-authentication/tellent-two-factor-authentication-effects.service';
import {
  TellentTwoFactorAuthenticationNamespace,
  TellentTwoFactorAuthenticationReducer,
} from './two-factor-authentication/tellent-two-factor-authentication.store';

const provideTellentTwoFaState = provideState(
  TellentTwoFactorAuthenticationNamespace,
  TellentTwoFactorAuthenticationReducer,
);
const provideTellentTwoFaEffects = provideEffects(TellentTwoFactorAuthenticationEffects);

export const tellentTwoFaData = [provideTellentTwoFaState, provideTellentTwoFaEffects];
